<template>
  <div class="library">
    <div class="library">
      <div ref="rmtLeft" id="rmtLeft" class="rmt-left">
        {{ $route.params.option }}
        <div class="left-block" :class="(RMTEditMode && !inUploadMode && !inCreateCollectionMode) ? 'fade-in-block' : ''"></div>
        <div ref="header" id="header" class="sticky-header">
          <div ref="headerHolder" class="header-holder">
            <HeaderBlock/>
            <SelectionHeader
              v-show="!inUploadMode"
              :selections="[
                { name: 'RESOURCES', func: setRMTSearchType },
                { name: 'COLLECTIONS', func: setRMTSearchType },
              ]"
            />
            <SearchBar v-show="!inUploadMode && panelIsHidden" />
            <SearchMenu v-show="!inUploadMode" />
          </div>
        </div>
        <div v-show="!inUploadMode && RMTSearchType === 0" class="results-holder">
          <SearchResults type="resources" />
        </div>
        <div v-show="!inUploadMode && RMTSearchType === 1" class="results-holder">
          <SearchResults type="collections" />
        </div>
        <UploadQueue v-if="inUploadMode" />
        <CollectionItemsPanel></CollectionItemsPanel>
      </div>

      <div class="rmt-right"  id="rmtRight" ref="rmtRight" @click="handleRightClick">

          <ResourcePanel v-if="RMTSearchType === 0"/>
          <CollectionPanel v-if="RMTSearchType === 1"/>

      </div>
    </div>
  </div>
</template>

<script>
import HeaderBlock from '@/components/header/HeaderBlock';
import SelectionHeader from '@/components/header/SelectionHeader';
import SearchResults from '@/components/libraries/SearchResults';
import ImageUpload from '@/components/rmt/ImageUpload';
import AddAsset from '@/components/rmt/AddAsset';
import { useRMTStore } from '@/store/RMTStore';
import UploadQueue from '@/components/rmt/UploadQueue';
import { storeToRefs } from 'pinia';
import { mapStores } from 'pinia/dist/pinia';
import { useModalStore } from '@/store/ModalStore';
import { useIdentityStore } from '@/store/IdentityStore';
import {useAuthStore} from '@/store/auth.store';
import {usePermissionStore} from '@/store/PermissionStore';
import CollectionPanel from '@/components/rmt/CollectionPanel';
import ResourcePanel from '@/components/rmt/ResourcePanel';
import SearchMenu from '@/components/libraries/search/SearchMenu';
import SearchBar from '@/components/libraries/SearchBar';
import CollectionItemsPanel from '@/components/rmt/CollectionItemsPanel';


export default {
  name: 'RMTView',
  components: {
    CollectionItemsPanel,
    ResourcePanel,
    ImageUpload,
    AddAsset,
    HeaderBlock,
    SelectionHeader,
    SearchMenu,
    SearchBar,
    SearchResults,
    UploadQueue,
    CollectionPanel
  },
  setup () {
    const RMTStore = useRMTStore();
    const { RMTSearchType, panelIsHidden, RMTPermission, RMTEditMode, inCreateCollectionMode } = storeToRefs(RMTStore);
    const identityStore = useIdentityStore();
    const authStore = useAuthStore();
    const modalStore = useModalStore();
    const permissionStore = usePermissionStore();
    return {
      RMTStore,
      RMTSearchType,
      RMTPermission,
      RMTEditMode,
      panelIsHidden,
      identityStore,
      authStore,
      modalStore,
      permissionStore,
      inCreateCollectionMode
    };
  },
  data () {
    return {
      lastScroll: 0,
      currentScroll: 0
    };
  },
  computed: {

    ...mapStores(useRMTStore, useModalStore, usePermissionStore),
    inUploadMode () {
      const RMTStore = useRMTStore();
      return RMTStore.inUploadMode;
    },
    uploadedFileData () {
      const RMTStore = useRMTStore();
      return RMTStore.uploadedFileData;
    },
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    selectionCount () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedResources.length;
    },
    tagsForSelectedResource () {
      const RMTStore = useRMTStore();
      return RMTStore.tagsForSelectedResource;
    },
  },
  watch: {
    RMTSearchType (t, o) {
      this.RMTStore.setPageY(o, this.$refs.rmtLeft.scrollTop);
    },
    panelIsHidden (to) {
      if (!to) {
        this.handleShow();
      } else {
        this.handleHide();
      }
    }
  },
  unmounted () {
    this.RMTStore.inUploadMode = false;
    this.RMTSearchType = 0;
  },
  mounted () {
    const RMTStore = useRMTStore();
    // todo: getting this working using strings but should use id from server
    localStorage.setItem(
      'recent',
      JSON.stringify([
        'Soybeans',
        'Stonefruit',
        'Sugar Beets',
        'Green',
        'Crops',
        'Permission 1',
      ])
    );
    RMTStore.clearSelections();
    RMTStore.setRMTSearchType(0);
  },
  created () {
    const RMTStore = useRMTStore();
    const permissionStore = usePermissionStore();
    RMTStore.created();
    let permission = this.identityStore.getRMTPermission();
    RMTStore.RMTPermission = permission;
    if (RMTStore.RMTPermission){
      permissionStore.fetchPermissions();
      this.RMTStore.fetchLibraryTypes();
      this.RMTStore.fetchLibraryCategories();
    }
  },
 
  methods: {
/*    onScroll () {
      let h = this.$refs.header.getBoundingClientRect().height;
      this.lastScroll = this.currentScroll;
      this.currentScroll = this.$refs.rmtLeft.scrollTop;
      if (this.$refs.rmtLeft.scrollTop > 0) {
        this.$refs.header.style.top = -h + 'px';
      }
      if (this.lastScroll >= this.currentScroll) {
        this.$refs.header.style.transition = 'all .3s ease-out';
        this.$refs.header.style.top = '0';
      }
      this.handleScroll();
    },*/
/*    handleScroll () {
      if (this.RMTStore.getSearchType === 1) { return; }
      let scrolledPercentage = (100 * this.$refs.rmtLeft.scrollTop) / (this.$refs.rmtLeft.scrollHeight - this.$refs.rmtLeft.clientHeight);
      if (scrolledPercentage > 90 && !this.RMTStore.isLoading) {
        this.RMTStore.fetchPage();
      }
    },*/
    hidePanel () {
      const RMTStore = useRMTStore();
      RMTStore.setPanelIsHidden(true);
    },
    filterResources (event) {
      this.RMTStore.filterResources(event).catch((error) => {
        console.log('Error: ' + JSON.stringify(error));
      });
    },
    handleUploadCancel () {
      this.RMTStore.setPanelIsHidden(true);
      this.RMTStore.uploadedFileData = [];
      this.RMTStore.filterUploadResources = [];
      this.RMTStore.setSelectedItemNum(0);
      this.RMTStore.data = [
        { label: 'file name', placeholder: 'name_of_file.jpg', value: 'resourceUri' },
        { label: 'title', placeholder: 'Image Title', value: 'name' },
        { label: 'description', placeholder: 'Image Description', value: 'description' },
        { label: 'alt tag', placeholder: 'Alt tag', value: 'alt' }
      ];
      this.RMTStore.inUploadMode = false;
    },
    handleSave () {
      this.RMTStore.saveStuff();
    },
    handleShow () {
      this.$refs.rmtLeft.classList.add('left-compact');
      this.$refs.rmtRight.style.transform = 'translateX(0%)';
    },
    setRMTSearchType (num) {
      this.RMTStore.uploadedFileData = [];
      this.RMTStore.panelIsHidden = true;
      document.getElementById('rmtLeft').scrollTo(0,0);
      this.RMTStore.clearSelectedResources();
      this.RMTStore.setRMTSearchType(num);
    },
    handleHide () {
      if (this.$refs.rmtLeft === null) { return; }
      this.$refs.rmtLeft.classList.remove('left-compact');
      this.$refs.rmtRight.style.transform = 'translateX(100%)';
      this.RMTStore.RMTEditMode = false;
    },
    handleRightClick () {
      if (!this.RMTStore.RMTPermission) { return; }
      this.RMTStore.RMTEditMode = true;
    },

  },
};
</script>

<style>
.rmt-left {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  transition: width .3s;
  overflow-x: hidden;
}

.left-compact {
  width: 65%;
  min-width: calc(100% - 420px);
}

@media (max-width: 1024px) {
  .left-compact {
    width: 50%;
    min-width: calc(1024px - 420px - 27px - 32px);
  }
}

@media (max-width: 768px) {
  .left-compact {
    width: 50%;
    min-width: 0;
  }
}

.rmt-right {
  position: absolute;
  right: 0;
  width: calc(35% - 27px);
  max-width: 420px;
  height: 100vh;
  background-color: whitesmoke;
  border-left: 1px solid whitesmoke;
  z-index: 1000;
/*  overflow-x: visible;
  overflow-y: auto;*/
/*  overflow: scroll;*/
  transform: translateX(100%);
  transition: right 1s, width .3s, transform .3s;

}

@media (max-width: 1024px) {
  .rmt-right {
    width: calc(50% - 27px);
  }
}



/*.rmt-edit-right {
  height: calc(100% - 70px);
}*/

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #8f54a0 #ffffff;
}
/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 11px;
  height: 11px;
}
*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.0);
}
*::-webkit-scrollbar-thumb {
  margin: 2px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: inset 0 0 10px 10px #d0d0d0;
  border: solid 3px transparent;
}
.right-action-holder {
  margin-top: 20px;
  padding-right: 20px;
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
.save-btn {
  cursor: pointer;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
}

.left-block {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(238,238,238,.85);
  z-index: 800;
  opacity: 0;
  transition: .2s opacity;
  pointer-events: none;
}

.fade-in-block {
  opacity: 1;
  pointer-events: all;
}
</style>

<style scoped>
/*.blue {
  background-color: blue !important;
}*/
.header-holder {
  box-shadow: 2px 4px 43px -32px #A6B5A6;
}
.library {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: space-between;
}
.results-holder {
  margin-top: 5px;
  width: 100%;
  padding: 10px;
}
.sticky-header {
  position: sticky;
  background-color: white;
  width: 100%;
  z-index: 1;
}
.save-btn {
  cursor: pointer;
  margin-top: 20px;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
}
.cancel-btn {
  cursor: pointer;

  color: black;
  margin-top: 20px;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  font-weight: 500;
}
.cancel-btn:hover {
  background-color: #E7E7E7;
}
.image-upload-buttons {
  display: flex;
  flex-direction: row-reverse;
}
</style>